module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/47da7e3f44ded85df850a542a90eafa3.png";